import { render, staticRenderFns } from "./v_Admin_Manage_Players.vue?vue&type=template&id=ba40cd8c&scoped=true&"
import script from "./v_Admin_Manage_Players.vue?vue&type=script&lang=js&"
export * from "./v_Admin_Manage_Players.vue?vue&type=script&lang=js&"
import style0 from "./v_Admin_Manage_Players.vue?vue&type=style&index=0&id=ba40cd8c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba40cd8c",
  null
  
)

export default component.exports